<template>
	<div class="d-flex flex-column result-display">
		<div class="sortition-name text-center black-color">
			{{ result.sortition.name }}
		</div>
		<div class="sortition-date text-center" :class="{'white-color': white, 'black-color': !white}">{{ result.date }}</div>
		<v-row no-gutters>
			<v-col md="6" lg="6" class="align-self-center border-right">
				<v-row no-gutters>
					<v-col>
						<result-digit-display
							:value="result.first"
							text="1st"
							left
							:white="white"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<result-digit-display
							:value="result.second"
							text="2nd"
							left
							:white="white"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<result-digit-display
							:value="result.third"
							text="3rd"
							left
							:white="white"
						></result-digit-display>
					</v-col>
				</v-row>
			</v-col>
			<v-col md="6" lg="6">
				<v-row no-gutters v-if="result.pickTwo">
					<v-col cols="12">
						<v-img height="30" contain :src="pick2"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.pickTwo"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">
						<v-img height="30" contain :src="pick3"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.cashThree"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col cols="12">
						<v-img height="30" contain :src="pick4"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.pickFour"
						></result-digit-display>
					</v-col>
				</v-row>
				<v-row v-if="result.pickFive" no-gutters>
					<v-col cols="12">
						<v-img height="30" contain :src="pick5"/>
					</v-col>
					<v-col cols="12">
						<result-digit-display
							class="d-flex justify-center"
							:value="result.pickFive"
						></result-digit-display>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import ResultDigitDisplay from './ResultDigitDisplay.vue';
	import pick2 from './images/pick2.png';
	import pick3 from './images/pick3.png';
	import pick4 from './images/pick4.png';
	import pick5 from './images/pick5.png';

	export default {
		name: 'ResultDisplay',
		components: { ResultDigitDisplay },
		props: {
			result: {
				type: Object,
				required: true
			},
			white: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				pick2,
				pick3,
				pick4,
				pick5
			};
		}
	};
</script>
<style scoped lang="scss">
	@import "css/variables";

	.sortition-name {
		line-height: 15px;
		font-size: 1.4rem;
		font-weight: bold;
	}

	.white-color {
		color: white;
	}
	.black-color {
		color: $black;
	}

	.next-drawing-text {
		color: white;
	}

	.sortition-date {
		font-size: 1.1rem;
	}

	.first,
	.second,
	.third {
		display: flex;
		flex-direction: column;
		margin-top: 0;

		.header {
			line-height: 35px;
			text-align: center;
		}
	}
</style>
